import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProgramBudgetComponent } from './program-budget.component';

const routes: Routes = [
  {
    path: '',
    component: ProgramBudgetComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProgramBudgetRoutingModule { }
